import { Outlet } from 'react-router-dom'
import Lottie from 'lottie-react'
import bottomAnimation from '@/assets/lottie/bottom.json'
import { isSafari } from '@/utils/browser.js'
import { TypographyXSmallMuted } from '@/components/ui/typography.jsx'

export default function AuthLayout({ children }) {
    return (
        <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-background to-primary-100/60 relative">
            <Lottie
                style={{ width: "100%", position: "absolute", top: "0", left: "0", transform: "rotate(180deg)", zIndex: "10", display: isSafari() ? "none" : "block" }}
                animationData={bottomAnimation}
            />

            <Lottie
                style={{ width: "100%", position: "absolute", bottom: "0", left: "50%", transform: "translateX(-50%)", zIndex: "10", display: isSafari() ? "none" : "block" }}
                animationData={bottomAnimation}
            />
            <div className="w-full max-w-md z-40">
                {children ? children : <Outlet />}
            </div>
            <div className="absolute bottom-4 z-50 flex gap-2 items-center">
                {/*<a href="https://upspring.ai/privacy-policy" target="_blank">*/}
                {/*    <TypographyXSmallMuted className="hover:underline">*/}
                {/*        Privacy Policy*/}
                {/*    </TypographyXSmallMuted>*/}
                {/*</a>*/}
                {/*<a href="https://upspring.ai/terms-of-use" target="_blank">*/}
                {/*    <TypographyXSmallMuted className="hover:underline">*/}
                {/*        Terms of use*/}
                {/*    </TypographyXSmallMuted>*/}
                {/*</a>*/}
                <a href="https://upspring.ai/refund-policy" target="_blank">
                    <TypographyXSmallMuted className="hover:underline">
                        Refund Policy
                    </TypographyXSmallMuted>
                </a>
            </div>
        </div>
    )
}